module.exports = __webpack_public_path__ + "static/media/banner_420x230_4.74e9f4d0.jpg";